// extracted by mini-css-extract-plugin
export default {"wrap":"SelectItem_wrap__f8w93","title":"SelectItem_title__5akXr","closeIcon":"SelectItem_closeIcon__MncAg"};